import { render, staticRenderFns } from "./WorkoutForm.vue?vue&type=template&id=bdfc47f2"
import script from "./WorkoutForm.vue?vue&type=script&lang=js"
export * from "./WorkoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports